import { motion } from "framer-motion";
import { Smartphone, Briefcase } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PlayButton } from "@/components/Bits";
import { APP_LINKS } from "@/data/site";

const qr = (key) => (process.env.PUBLIC_URL || "") + "/qr-" + key + ".png";

const PANELS = [
  {
    key: "customer",
    icon: Smartphone,
    tag: "For customers",
    title: "Book any service in seconds",
    desc: "Electrician se beauty tak — sab kuch ek hi app me. Scan karo ya download karo.",
    link: APP_LINKS.customer,
    btnLabel: "BOOK A SERVICE",
    btnStore: "Customer App",
    testid: "app-download-customer",
  },
  {
    key: "partner",
    icon: Briefcase,
    tag: "For professionals",
    title: "Grow your work & earnings",
    desc: "Apne sheher me daily jobs paao aur reliable weekly payout ke saath kamao.",
    link: APP_LINKS.partner,
    btnLabel: "EARN AS PARTNER",
    btnStore: "Partner App",
    testid: "app-download-partner",
  },
];

export default function AppDownload() {
  return (
    <section className="relative py-20 sm:py-28 bg-azo-surface border-y border-azo-border" data-testid="app-download-banner">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <Reveal className="inline-flex items-center gap-2 text-azo-primary font-mono2 text-xs uppercase tracking-widest mb-4 justify-center">
            <span className="h-px w-8 bg-azo-primary" /> Get the apps <span className="h-px w-8 bg-azo-primary" />
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-heading font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
              Two apps. One AzoApp family.
            </h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {PANELS.map((p, i) => (
            <motion.div
              key={p.key}
              initial={{ opacity: 0, y: 34 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.75, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 }}
              data-testid={p.testid}
              className={`relative overflow-hidden rounded-3xl border border-azo-border p-7 sm:p-9 ${
                p.key === "customer" ? "bg-azo-primary text-white" : "bg-azo-bg"
              }`}
            >
              {p.key === "customer" && (
                <div className="pointer-events-none absolute -bottom-20 -right-16 h-64 w-64 rounded-full bg-white/10 blur-2xl" />
              )}
              <div className="relative z-10 flex flex-col sm:flex-row gap-6 items-start justify-between">
                <div className="flex-1">
                  <span className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium ${
                    p.key === "customer" ? "bg-white/15" : "bg-azo-primary/12 text-azo-primary"
                  }`}>
                    <p.icon size={14} /> {p.tag}
                  </span>
                  <h3 className={`mt-5 font-heading font-bold text-2xl leading-tight ${p.key === "customer" ? "text-white" : "text-azo-text"}`}>
                    {p.title}
                  </h3>
                  <p className={`mt-2.5 text-sm leading-relaxed ${p.key === "customer" ? "text-white/80" : "text-azo-muted"}`}>
                    {p.desc}
                  </p>
                  <div className="mt-6">
                    <PlayButton
                      href={p.link}
                      label={p.btnLabel}
                      store={p.btnStore}
                      variant={p.key === "customer" ? "ghost" : "solid"}
                      testid={`${p.testid}-btn`}
                    />
                  </div>
                </div>
                <div className="shrink-0 rounded-2xl bg-white p-3 shadow-azo">
                  <img src={qr(p.key)} alt={`${p.btnStore} Google Play QR code`} className="h-28 w-28 sm:h-32 sm:w-32" loading="lazy" />
                  <p className="mt-1.5 text-center text-[10px] font-mono2 uppercase tracking-widest text-azo-primary">Scan me</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
